import React from 'react';

// Bot trap for the signup forms (see server/middleware/signupBotGuard.js).
// Invisible and unreachable for people: pushed off-screen, hidden from screen
// readers, skipped by Tab, autofill disabled. Anything typed in here means a
// script filled every field it found.
export default function HoneypotField({ value, onChange }) {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', top: 'auto', width: 1, height: 1, overflow: 'hidden' }}>
      <label>
        Leave this field empty
        <input
          type="text"
          name="hp_contact"
          tabIndex={-1}
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
    </div>
  );
}
